import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharedRoutingModule { }
